import ConnectDetailsSimpleForm from './ConnectDetailsSimpleForm'

export default ConnectDetailsSimpleForm
